var _metadata, _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApolloClient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-64 -42 807.89997 224.58265",
    width: 2076.6501,
    height: 610.22003,
    id: "svg10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata16"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g6",
    style: {
      fill: "#333333"
    },
    transform: "translate(-70.5,-56.051631)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 137.6,72.4 h -24.3 l -35.1,91.1 h 22 l 5.7,-15.5 h 33.2 l -6,-17 h -21.9 l 14.2,-39.2 25.3,71.7 h 22 z m 369.3,91.1 V 72.4 h 19.5 v 74 h 38.5 v 17.1 z m 112.5,0 V 72.4 H 639 v 74 h 38.5 v 17.1 z M 398.7,88.7 c 16.2,0 29.3,13.1 29.3,29.3 0,16.2 -13.1,29.3 -29.3,29.3 -16.2,0 -29.3,-13.1 -29.3,-29.3 0,-16.2 13.2,-29.3 29.3,-29.3 m 0,-17.8 c -26,0 -47.1,21.1 -47.1,47.1 0,26 21.1,47.1 47.1,47.1 26,0 47.1,-21.1 47.1,-47.1 0,-26 -21.1,-47.1 -47.1,-47.1 z m 368.6,17.8 c 16.2,0 29.3,13.1 29.3,29.3 0,16.2 -13.1,29.3 -29.3,29.3 -16.2,0 -29.3,-13.1 -29.3,-29.3 0,-16.2 13.1,-29.3 29.3,-29.3 m 0,-17.8 c -26,0 -47.1,21.1 -47.1,47.1 0,26 21.1,47.1 47.1,47.1 26,0 47.1,-21.1 47.1,-47.1 0,-26 -21.1,-47.1 -47.1,-47.1 z M 272,72.4 h -42.5 v 91.1 h 19.4 V 132.1 H 272 c 16.2,0 29.3,-13.7 29.3,-29.9 0,-16.1 -13.1,-29.8 -29.3,-29.8 z m 0,41.9 H 248.9 V 90.2 H 272 c 6.3,0 11.5,5.7 11.5,12 0,6.3 -5.2,12.1 -11.5,12.1 z",
    id: "path2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 212.8,191.1 c -1.7,0 -3.2,0.8 -4.1,2.1 0,0 -4.4,5 -6.7,7.4 -10,10 -21.6,17.8 -34.5,23.3 -13.4,5.7 -27.6,8.5 -42.3,8.5 -14.7,0 -28.9,-2.9 -42.3,-8.5 C 70,218.4 58.3,210.6 48.4,200.6 38.4,190.6 30.6,179 25.1,166.1 19.4,152.7 16.6,138.5 16.6,123.8 16.6,109.1 19.5,94.9 25.1,81.5 30.5,68.6 38.3,56.9 48.3,47 58.3,37 69.9,29.2 82.8,23.7 c 13.4,-5.7 27.6,-8.5 42.3,-8.5 14.7,0 28.9,2.9 42.3,8.5 9.4,4 18.1,9.2 26,15.6 -0.4,1.2 -0.7,2.6 -0.7,4 0,6.8 5.5,12.3 12.3,12.3 6.8,0 12.3,-5.5 12.3,-12.3 0,-6.8 -5.5,-12.3 -12.3,-12.3 -1.7,0 -3.3,0.3 -4.7,1 C 179.8,15.2 153.7,5.1 125.1,5.1 59.6,5.1 6.5,58.2 6.5,123.8 c 0,65.6 53.1,118.7 118.7,118.7 36.7,0 69.4,-16.6 91.2,-42.8 0.9,-0.9 1.5,-2.2 1.5,-3.5 -0.1,-2.8 -2.4,-5.1 -5.1,-5.1 z",
    id: "path4"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 838.1,233.54837 H -134.5 V -98.051631 h 972.6 z",
    id: "path8",
    style: {
      fill: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApolloClient);
export default __webpack_public_path__ + "static/media/Apollo-client.b2ffa1d75516f5cda051ea7d3eff1dd9.svg";
export { ForwardRef as ReactComponent };